import React, { Component } from 'react';
import PropType from 'prop-types';
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';

class Overlay extends Component {
    closeOnEscape = e => {
        const { closeModalCallback } = this.props;
        if (e.keyCode === 27) {
            if (!!closeModalCallback) {
                closeModalCallback();
            }
            e.preventDefault();
        }
    };

    componentDidMount() {
        const { scrollBodyCssId } = this.props;

        window.addEventListener('keydown', this.closeOnEscape);

        this.scrollableElement = document.getElementById(scrollBodyCssId);
        if (this.scrollableElement) {
            disableBodyScroll(this.scrollableElement);
        }
    }

    componentWillUnmount() {
        window.removeEventListener('keydown', this.closeOnEscape);
        clearAllBodyScrollLocks();
    }

    render() {
        const { children, closeModalCallback, height, zIndex } = this.props;

        return (
            <div
                style={{
                    position: 'fixed',
                    left: 0,
                    right: 0,
                    height: height,
                    minHeight: '100%',
                    zIndex: zIndex,
                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                    cursor: 'pointer',
                    transition: 'opacity 0.25s ease'
                }}
                onClick={() => {
                    closeModalCallback();
                }}>
                {children}
            </div>
        );
    }
}

Overlay.propTypes = {
    children: PropType.node,
    closeModalCallback: PropType.func,
    height: PropType.string,
    zIndex: PropType.number,
    scrollBodyCssId: PropType.string.isRequired
};

Overlay.defaultProps = {
    height: '100vh',
    zIndex: 1
};

export default Overlay;



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/components/modals/overlay.jsx